import axios from "axios";

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/pickUpCar`;

const FetchWorkshops = async () => (
	await axios.get(`${API_PATH}/getWorkshops`)
);

const ImportDriver = async resource => (
	await axios.post(`${API_PATH}/importDriver`, resource, { headers: { "Content-Type": "multipart/form-data"} })
);

const ImportImages = async resource => (
	await axios.post(`${API_PATH}/importDriver/photo`, resource, { headers: { "Content-Type": "multipart/form-data"} })
);

const UpdateDriver = async resource => (
	await axios.post(`${API_PATH}/update/driver`, resource, { headers: { "Content-Type": "multipart/form-data"} })
);

export { FetchWorkshops, ImportDriver, ImportImages, UpdateDriver };
